


const getFileExtension = (filename) => {
    // Split the filename by '.' and return the last part
    const parts = filename.split('.');
    return parts.length > 1 ? parts.pop().toLowerCase() : '';
}

export default getFileExtension;